module.exports = __webpack_public_path__ + "assets/images/diseases_r.e7c5e02b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/diseases_r.png
// module id = 702
// module chunks = 1